import { VerticalTab } from './components/VerticalTab';

export const ItrProductGuidePage = () => {
  return <VerticalTab />;
};
